import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "app-icon",
  templateUrl: "./icon.component.html",
  styleUrls: ["./icon.component.scss"],
})
export class IconComponent implements OnInit {
  data: string;
  @Input() src: string;
  @Input() alt: string;

  constructor(private sanitizer: DomSanitizer) {}

  async ngOnInit() {
    const response = await fetch(this.src).then((response) => response.text());
    this.data = this.sanitizer.bypassSecurityTrustHtml(response) as string;
  }
}
